import { __assign } from "tslib";
// DS: i5.7
import React from 'react';
import IconWrap from '../../IconWrap';
var Lock = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
        React.createElement("path", { d: "M12 4a5 5 0 015 5v2h2a1 1 0 011 1v8a1 1 0 01-1 1H5a1 1 0 01-1-1v-8a1 1 0 011-1h2V9a5 5 0 015-5zm6 9H6v6h12v-6zm-6 1a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm0-8a3 3 0 00-2.995 2.824L9 9v2h6V9a3 3 0 00-2.824-2.995L12 6z" })))); };
Lock.displayName = 'Lock';
export default Lock;
//# sourceMappingURL=Lock.js.map